import React from "react"
import ReactDOM from "react-dom"

export const escapeHtml = (str) =>
  String(str).replace(/[&<>"']/g, (c) => {
    if (c === "&") return "&amp;"
    if (c === "<") return "&lt;"
    if (c === ">") return "&gt;"
    if (c === '"') return "&quot;"
    return "&#39;"
  })

export const renderChartTooltipIntoPortal = (tooltipRef, tooltipModel, canvas) => {
  const el = tooltipRef.current
  if (!el) return

  if (!tooltipModel || tooltipModel.opacity === 0) {
    el.style.opacity = 0
    return
  }

  const titleLines = Array.isArray(tooltipModel.title) ? tooltipModel.title : []
  const bodyLines = []
  if (Array.isArray(tooltipModel.body)) {
    tooltipModel.body.forEach((b, i) => {
      const lines = (b && b.lines) || []
      const colors = tooltipModel.labelColors && tooltipModel.labelColors[i]
      lines.forEach((line) => bodyLines.push({ text: line, colors }))
    })
  }

  const titleHtml = titleLines.length
    ? `<div style="font-weight:600;margin-bottom:4px;font-size:12px;">${escapeHtml(
        titleLines.join(" ")
      )}</div>`
    : ""

  const bodyHtml = bodyLines
    .map(({ text, colors }) => {
      const bg = (colors && colors.backgroundColor) || "transparent"
      const bd = (colors && colors.borderColor) || "transparent"
      const swatch = `<span style="display:inline-block;width:12px;height:10px;margin-right:8px;flex-shrink:0;background:${bg};border:1px solid ${bd};box-sizing:border-box;"></span>`
      return `<div style="display:flex;align-items:center;margin-top:3px;">${swatch}<span>${escapeHtml(
        text
      )}</span></div>`
    })
    .join("")

  el.innerHTML = titleHtml + bodyHtml

  if (!canvas) return
  const canvasRect = canvas.getBoundingClientRect()
  el.style.display = "block"
  el.style.opacity = 1
  const ttWidth = el.offsetWidth
  const ttHeight = el.offsetHeight

  let left = canvasRect.left + tooltipModel.caretX - ttWidth / 2
  let top = canvasRect.top + tooltipModel.caretY - ttHeight - 12
  if (top < 8) top = canvasRect.top + tooltipModel.caretY + 14
  if (left < 8) left = 8
  if (left + ttWidth > window.innerWidth - 8) {
    left = window.innerWidth - ttWidth - 8
  }
  el.style.left = `${left}px`
  el.style.top = `${top}px`
}

export const PortalTooltipDiv = React.forwardRef((_, ref) => {
  if (typeof document === "undefined") return null
  return ReactDOM.createPortal(
    <div
      ref={ref}
      style={{
        position: "fixed",
        pointerEvents: "none",
        background: "rgba(0, 0, 0, 0.88)",
        color: "#fff",
        padding: "8px 11px",
        borderRadius: 4,
        fontSize: 11,
        lineHeight: 1.4,
        opacity: 0,
        transition: "opacity 0.08s ease-out",
        zIndex: 99999,
        whiteSpace: "nowrap",
        left: 0,
        top: 0,
        boxShadow: "0 2px 8px rgba(0,0,0,0.25)",
      }}
    />,
    document.body
  )
})

PortalTooltipDiv.displayName = "PortalTooltipDiv"
